import { Injectable } from '@angular/core';
import { DepartmentVM, DropdownOptionVM, OfferVM, SegmentVM } from '../models/home.vm';

/**
 * Proyecta los catálogos públicos (segmentos, ofertas, departamentos,
 * ciudades, zonas) a ViewModels listos para el buscador. Concentra la
 * presentación (imagen de ciudad, color de oferta). Sin estado ni HTTP.
 */
@Injectable({ providedIn: 'root' })
export class CatalogOptionMapper {

    /** Imagen local por código de departamento (no viene del backend). */
    private static readonly DEPT_IMAGE: Record<string, string> = {
        LPZ: 'assets/layout/images/home/cities/LP.png',
        SCZ: 'assets/layout/images/home/cities/SC.png',
        CBBA: 'assets/layout/images/home/cities/CBBA.png',
        TJA: 'assets/layout/images/home/cities/TR.png',
        OR: 'assets/layout/images/home/cities/OR.png',
        PT: 'assets/layout/images/home/cities/PT.png',
        BN: 'assets/layout/images/home/cities/BN.png',
        CHQ: 'assets/layout/images/home/cities/CQ.png',
        PN: 'assets/layout/images/home/cities/PN.png',
    };

    /** Color de botón por código de acción/oferta. */
    private static readonly OFFER_COLOR: Record<string, string> = {
        SALE: '#006699',
        RENT: '#FFD680',
        LEASING: '#B4C68C',
        BANK_AUCTION: '#F5947A',
    };

    toSegments(list: any[] | null | undefined): SegmentVM[] {
        return (list ?? []).map((s) => ({
            segmentId: s.segmentId,
            label: s.segmentLabel,
            icon: s.fileUrl,
        }));
    }

    toOffers(list: any[] | null | undefined): OfferVM[] {
        return (list ?? []).map((o) => ({
            adId: o.adId,
            label: o.adLabel,
            color: CatalogOptionMapper.OFFER_COLOR[o.adCode] ?? null,
        }));
    }

    /** Solo departamentos con imagen de ciudad disponible. */
    toDepartments(list: any[] | null | undefined): DepartmentVM[] {
        return (list ?? [])
            .map((d) => ({
                code: d.optionCode,
                name: d.optionName,
                image: CatalogOptionMapper.DEPT_IMAGE[d.optionCode],
            }))
            .filter((d) => !!d.image);
    }

    toCityOptions(list: any): DropdownOptionVM[] {
        return (Array.isArray(list) ? list : []).map((c) => ({
            label: c.cityName,
            value: c.cityId,
        }));
    }

    toZoneOptions(list: any): DropdownOptionVM[] {
        return (Array.isArray(list) ? list : []).map((z) => ({
            label: z.zoneName,
            value: z.zoneId,
        }));
    }
}
